import { render, staticRenderFns } from "./ReviewWriteMoveGuideDialog.vue?vue&type=template&id=0cf4d6c1&scoped=true"
import script from "./ReviewWriteMoveGuideDialog.vue?vue&type=script&lang=js"
export * from "./ReviewWriteMoveGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewWriteMoveGuideDialog.vue?vue&type=style&index=0&id=0cf4d6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4d6c1",
  null
  
)

export default component.exports